var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc_scroll-tab",on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_c('ul',{staticClass:"activity-rule-nav",class:{ 'show-all': _vm.isExpanded }},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:[
        index == _vm.active || (item.brandId && _vm.activeId && _vm.activeId == item.brandId)
          ? 'active'
          : ''
      ],on:{"click":function($event){return _vm.handleSetActive(item, index, $event)}}},[_vm._v(" "+_vm._s(item.tabName || item.name || item.categoryName || item.brandName)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }